import { api, accountRoutes } from "../../..";
import { ApiConfig } from "../../../ApiConfig";
const baseURL = ApiConfig.baseApi;

// ----------------------------------------------------------------
// Define allowance services
// ----------------------------------------------------------------

const services = {

  // ----------------------------------------------------------------
  // Get all allowance type
  // ----------------------------------------------------------------

  get: async (page = 1, sort, companyToken) => {
    const token = localStorage.getItem("accessToken");
    const params = new URLSearchParams();

    if (page) params.append("page", page);
    if (sort) params.append("sort", sort);

    const url = `${baseURL}${accountRoutes.allowance_type.get}`;

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${companyToken}`,
    };
    return api.get(url, params, headers);
  },

  // ----------------------------------------------------------------
  // post allowance type
  // ----------------------------------------------------------------

  post: (data, fringeTax, country) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + accountRoutes.allowance_type.post;
    const params = {
      name: data,
      isTaxable: fringeTax
    };
    // Add country only if it's a non-empty string
    if (country && country.trim() !== "") {
      params.country = country;
    }
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, params, headers);
  },

  put: (data, id, allowanceText, country) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + accountRoutes.allowance_type.put + id;
    const params = {
      name: data,
      isTaxable: allowanceText
    };
    // Add country only if it's a non-empty string
    if (country && country.trim() !== "") {
      params.country = country;
    }
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.put(url, params, headers);
  },

  delete: (id) => {
    const token = localStorage.getItem("accessToken");
    //  const { baseApi, handleSales } = ApiConfig;
    const url = baseURL + accountRoutes.allowance_type.delete + id;

    const params = {};
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.delete(url, params, headers);
  },

  // ----------------------------------------------------------------
  //  Contributions type
  // ----------------------------------------------------------------


  ContributionsPost: (contribution, contributionText) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + accountRoutes.contributin_type.Post;
    const params = {
      name: contribution,
      isTaxable: contributionText
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, params, headers);
  },

  contributionsPut: (contribution, editContribution, contributionText) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + accountRoutes.contributin_type.put + editContribution;
    const params = {
      name: contribution,
      isTaxable: contributionText
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.put(url, params, headers);
  },

  contributionsDelete: (id) => {
    const token = localStorage.getItem("accessToken");
    //  const { baseApi, handleSales } = ApiConfig;
    const url = baseURL + accountRoutes.contributin_type.delete + id;

    const params = {};
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.delete(url, params, headers);
  },

  // ----------------------------------------------------------------
  //  Levies type
  // ----------------------------------------------------------------


  LeviesPost: (levies, leviesText) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + accountRoutes.levies_type.post;
    const params = {
      name: levies,
      isTaxable: leviesText
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.post(url, params, headers);
  },

  leviesPut: (levies, editLevies, leviesText) => {
    const token = localStorage.getItem("accessToken");
    const url = baseURL + accountRoutes.levies_type.put + editLevies;
    const params = {
      name: levies,
      isTaxable: leviesText
    };
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.put(url, params, headers);
  },

  leviesDelete: (id) => {
    const token = localStorage.getItem("accessToken");
    //  const { baseApi, handleSales } = ApiConfig;
    const url = baseURL + accountRoutes.levies_type.delete + id;

    const params = {};
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    return api.delete(url, params, headers);
  },


};

// Export the services
export default services;
